import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProjectsService {


  url = environment.serverAPI9 + "/api/projects";

  constructor(private http: HttpClient) { }

  getAllProjects(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllProjectsDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }


  getProjectsById(projectId: number): Observable<Object> {
    return this.http.get(`${this.url}/${projectId}`);
  }

  addOrEditProjects(projects: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, projects);
  }

  ProjectsSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  deleteImage(data: any): Observable<Object> {
    return this.http.post(`${this.url}/deleteImage`, data);
  }

  deleteByClientId(id: any): Observable<Object> {
    return this.http.delete(`${this.url}/${id}`);
  }

  downloadProjectTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, { responseType: 'arraybuffer', observe: 'response' });
  }

  uploadProjects(payload: unknown): Observable<any> {
    return this.http.post<any>(`${this.url}/bulk/import`, payload);
  }

  downloadProjectsReport(Page: number, size: number, sort, selectionUnits): Observable<any> {
    return this.http.post(`${this.url}/export/page?page=${Page}
    &size=${size}&sort=${sort}`, selectionUnits, {
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }

}
